import { render } from "./MakeTestimonial.vue?vue&type=template&id=e21ff34e&scoped=true"
import script from "./MakeTestimonial.vue?vue&type=script&lang=js"
export * from "./MakeTestimonial.vue?vue&type=script&lang=js"

import "./MakeTestimonial.vue?vue&type=style&index=0&id=e21ff34e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e21ff34e"]])

export default __exports__